// Enhanced Schema.org markup generators with full SEO optimization

export const generateLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "PestControlService"],
  "@id": "https://www.reclaimpestcontrol.com/#organization",
  "name": "Reclaim Pest Control",
  "alternateName": "Reclaim Exterminating",
  "description": "NYC's trusted pest control company providing fast, reliable, and affordable professional pest control services. We help homeowners, renters, tenants, landlords, property managers, and businesses eliminate rodents, roaches, bed bugs, ants, mice, rats, wasps, fleas, mites, moths and other pests—safely and effectively.",
  "image": [
    "https://www.reclaimpestcontrol.com/images/logo.png",
    "https://www.reclaimpestcontrol.com/images/hero-technician.webp"
  ],
  "url": "https://www.reclaimpestcontrol.com",
  "telephone": "+16462099955",
  "email": "reclaimexterminating@gmail.com",
  "priceRange": "$$",
  "currenciesAccepted": "USD",
  "paymentAccepted": "Cash, Credit Card, Debit Card",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "New York",
    "addressRegion": "NY",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 40.7128,
    "longitude": -74.0060
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    }
  ],
  "areaServed": [
    {"@type": "City", "name": "Brooklyn", "containedInPlace": {"@type": "State", "name": "New York"}},
    {"@type": "City", "name": "Queens", "containedInPlace": {"@type": "State", "name": "New York"}},
    {"@type": "City", "name": "Manhattan", "containedInPlace": {"@type": "State", "name": "New York"}},
    {"@type": "City", "name": "Bronx", "containedInPlace": {"@type": "State", "name": "New York"}},
    {"@type": "City", "name": "Staten Island", "containedInPlace": {"@type": "State", "name": "New York"}},
    {"@type": "AdministrativeArea", "name": "Nassau County"},
    {"@type": "AdministrativeArea", "name": "Suffolk County"},
    {"@type": "AdministrativeArea", "name": "Westchester County"},
    {"@type": "AdministrativeArea", "name": "Long Island"},
    {"@type": "AdministrativeArea", "name": "Hempstead"}
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pest Control Services",
    "itemListElement": [
      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Rodent Control", "description": "Complete rat and mice extermination"}},
      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Bed Bug Removal", "description": "Heat treatment and IPM methods"}},
      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Cockroach Extermination", "description": "German, American, Oriental roach control"}},
      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Termite Control", "description": "Inspection and treatment"}},
      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Ant Extermination", "description": "Carpenter ant and general ant removal"}},
      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Wasp Removal", "description": "Safe nest removal"}},
      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Flea Control", "description": "Pet-safe flea treatments"}},
      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Spider Control", "description": "Spider and web removal"}}
    ]
  },
  "slogan": "New York's Reliable Pest Control & Extermination Company",
  "knowsAbout": [
    "Pest Control", "Extermination", "Bed Bug Removal", "Rodent Control", 
    "Termite Inspection", "Cockroach Control", "Ant Control", "Wasp Removal",
    "Flea Treatment", "NYC Pest Control", "Commercial Pest Control"
  ],
  "makesOffer": [
    {
      "@type": "Offer",
      "name": "Free Pest Inspection",
      "description": "Complimentary pest inspection for homes and businesses",
      "price": "0",
      "priceCurrency": "USD"
    }
  ]
});

export const generateServiceSchema = (service) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": `https://www.reclaimpestcontrol.com/services/${service.slug}`,
  "serviceType": service.name,
  "name": service.name,
  "description": service.full_description || service.short_description,
  "provider": {
    "@type": "PestControlService",
    "@id": "https://www.reclaimpestcontrol.com/#organization",
    "name": "Reclaim Pest Control",
    "telephone": "+16462099955",
    "url": "https://www.reclaimpestcontrol.com"
  },
  "areaServed": {
    "@type": "State",
    "name": "New York"
  },
  "offers": {
    "@type": "Offer",
    "availability": "https://schema.org/InStock",
    "priceCurrency": "USD",
    "priceSpecification": {
      "@type": "PriceSpecification",
      "priceCurrency": "USD"
    }
  },
  "termsOfService": "Free inspection and quote",
  "serviceOutput": "Pest-free environment"
});

export const generateFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const generateBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `https://www.reclaimpestcontrol.com${item.url}`
  }))
});

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://www.reclaimpestcontrol.com/#organization",
  "name": "Reclaim Pest Control",
  "url": "https://www.reclaimpestcontrol.com",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.reclaimpestcontrol.com/images/logo.png",
    "width": 200,
    "height": 60
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+16462099955",
    "contactType": "customer service",
    "email": "reclaimexterminating@gmail.com",
    "areaServed": "US",
    "availableLanguage": "English",
    "hoursAvailable": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    }
  },
  "foundingLocation": {
    "@type": "Place",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Queens",
      "addressRegion": "NY"
    }
  }
});

export const generateArticleSchema = (post) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "@id": `https://www.reclaimpestcontrol.com/blog/${post.slug}`,
  "headline": post.title,
  "description": post.excerpt,
  "image": post.featured_image ? `https://www.reclaimpestcontrol.com${post.featured_image}` : "https://www.reclaimpestcontrol.com/images/hero-technician.webp",
  "author": {
    "@type": "Organization",
    "name": "Reclaim Pest Control",
    "@id": "https://www.reclaimpestcontrol.com/#organization"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Reclaim Pest Control",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.reclaimpestcontrol.com/images/logo.png"
    }
  },
  "datePublished": post.published_date,
  "dateModified": post.published_date,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": `https://www.reclaimpestcontrol.com/blog/${post.slug}`
  },
  "keywords": post.tags?.join(", "),
  "articleSection": post.category,
  "wordCount": post.content?.split(/\s+/).length || 1000
});

export const generateHowToSchema = (title, steps) => ({
  "@context": "https://schema.org",
  "@type": "HowTo",
  "name": title,
  "description": `Step-by-step guide for ${title.toLowerCase()}`,
  "totalTime": "PT30M",
  "tool": [
    {"@type": "HowToTool", "name": "Professional pest control equipment"}
  ],
  "step": steps.map((step, index) => ({
    "@type": "HowToStep",
    "position": index + 1,
    "name": `Step ${index + 1}`,
    "text": step,
    "url": `https://www.reclaimpestcontrol.com/services#step${index + 1}`
  }))
});

export const generateWebPageSchema = (title, description, url) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": url,
  "name": title,
  "description": description,
  "url": url,
  "isPartOf": {
    "@type": "WebSite",
    "@id": "https://www.reclaimpestcontrol.com/#website",
    "name": "Reclaim Pest Control",
    "url": "https://www.reclaimpestcontrol.com"
  },
  "about": {
    "@type": "Thing",
    "name": "Pest Control Services"
  },
  "provider": {
    "@type": "Organization",
    "@id": "https://www.reclaimpestcontrol.com/#organization"
  }
});

export const generateServiceAreaSchema = (area) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Pest Control",
  "name": `Pest Control in ${area.name}`,
  "description": area.description,
  "provider": {
    "@type": "PestControlService",
    "@id": "https://www.reclaimpestcontrol.com/#organization"
  },
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": area.name,
    "containedInPlace": {
      "@type": "State",
      "name": area.state
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": `https://www.reclaimpestcontrol.com/service-areas/${area.slug}`,
    "servicePhone": "+16462099955"
  }
});


export const generateNeighborhoodSchema = (neighborhood, areaName, areaSlug) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Pest Control",
  "name": `Pest Control in ${neighborhood.name}, ${areaName}`,
  "description": `Professional pest control services in ${neighborhood.name}, ${areaName}. Expert extermination for rodents, bed bugs, roaches & more. 24/7 service available.`,
  "provider": {
    "@type": "PestControlService",
    "@id": "https://www.reclaimpestcontrol.com/#organization",
    "name": "Reclaim Pest Control",
    "telephone": "+16462099955"
  },
  "areaServed": {
    "@type": "Place",
    "name": neighborhood.name,
    "address": {
      "@type": "PostalAddress",
      "addressLocality": neighborhood.name,
      "addressRegion": "NY",
      "postalCode": neighborhood.zip_codes?.[0] || "",
      "addressCountry": "US"
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": `https://www.reclaimpestcontrol.com/service-areas/${areaSlug}/${neighborhood.slug}`,
    "servicePhone": "+16462099955"
  },
  "offers": {
    "@type": "Offer",
    "name": "Free Pest Inspection",
    "price": "0",
    "priceCurrency": "USD",
    "availability": "https://schema.org/InStock"
  }
});

